import { render, staticRenderFns } from "./letter-modify.vue?vue&type=template&id=48021587&scoped=true"
import script from "./letter-modify.vue?vue&type=script&lang=ts"
export * from "./letter-modify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48021587",
  null
  
)

export default component.exports